import { Component, OnInit } from '@angular/core';
import { AccountingReportsService } from '../accounting-reports.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AccountingProfitAndLossModel } from '../../models/accounting-profitandloss.model';
import { Utils } from '../../../../shared/utils';
import * as FileSaver from 'file-saver';
import { UntypedFormControl, Validators } from '@angular/forms';
import { CoreComponent } from '../../../../core/header/core.component';
import { consts } from '../../../../consts';
import { Option } from '../../../../shared/models/option.model';

@Component({
    selector: 'convfact-accounting-profitandloss',
    templateUrl: './accounting-profitandloss.component.html',
    styleUrls: ['./accounting-profitandloss.component.css'],
    standalone: false
})
export class AccountingProfitAndLossComponent implements OnInit {
  public isLoading: boolean = false;
  public accountingProfitAndLossModel: AccountingProfitAndLossModel;

  public fromFilterBalance: UntypedFormControl;
  public toFilterBalance: UntypedFormControl;
  public globalFilterBalance: UntypedFormControl;

  public fromToFilterBalanceOptions: Option[] = [
    { label: 'Apertura', value: '0' },
    ...['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
      .map((m, i) => ({ label: m, value: (i + 1).toString() })),
    { label: 'Regularización', value: '13' },
    { label: 'Cierre', value: '14' },
  ];

  constructor(
    private accountingReportsService: AccountingReportsService,
    public snackBar: MatSnackBar,
    public core: CoreComponent
  ) {
    this.accountingProfitAndLossModel = new AccountingProfitAndLossModel();
  }

  ngOnInit(): void {
    this.setDefaultValesFormControl();
    this.loadBalanceProfitAndLoss();
  }

  private setDefaultValesFormControl(): void {
    const actualDate: Date = new Date();
    let actualMonth: number = actualDate.getMonth();
    actualMonth++;

    this.fromFilterBalance = new UntypedFormControl('0', [Validators.required]);
    this.toFilterBalance = new UntypedFormControl(actualMonth.toString(), [Validators.required]);

    const activities = this.core.activity;
    if (activities.length == 1) {
      this.globalFilterBalance = new UntypedFormControl(true, [Validators.requiredTrue]);
    } else {
      this.globalFilterBalance = new UntypedFormControl(false, [Validators.requiredTrue]);
    }
  }

  private loadBalanceProfitAndLoss(): void {
    this.isLoading = true;

    this.accountingReportsService
      .getProfitAndLossModel(
        this.globalFilterBalance.value,
        this.fromFilterBalance.value,
        this.toFilterBalance.value
      )
      .then(response => {
        this.accountingProfitAndLossModel = response;
        this.isLoading = false;
      })
      .catch(err => {
        this.displayInfo(err['message']);
        this.isLoading = false;
      });
  }

  public filterBalance(): void {
    this.loadBalanceProfitAndLoss();
  }

  public excel(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.isLoading = true;

    const request = {
      global: this.globalFilterBalance.value,
      from: this.fromFilterBalance.value,
      to: this.toFilterBalance.value,
      profitAndLossViewModel: this.accountingProfitAndLossModel
    };

    this.accountingReportsService
      .getExcelProfitAndLoss(request)
      .then(response => {
        FileSaver.saveAs(response, Utils.GetExcelName('Pérdida y Ganancias Pymes'));
        this.isLoading = false;
      })
      .catch(() => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel');
        this.isLoading = false;
      });
  }

  public pdf(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.isLoading = true;

    const request = {
      global: this.globalFilterBalance.value,
      from: this.fromFilterBalance.value,
      to: this.toFilterBalance.value,
      profitAndLossViewModel: this.accountingProfitAndLossModel
    };

    this.accountingReportsService
      .getPdfProfitAndLoss(request)
      .then(response => {
        FileSaver.saveAs(response, Utils.GetPdfName('Pérdida y Ganancias Pymes'));
        this.isLoading = false;
      })
      .catch(() => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento PDF');
        this.isLoading = false;
      });
  }

  private displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }
  public trackByIndex(i: number) { return i; }

}